import React from 'react'
import SubFooter from './components/SubFooter'
import MainFooter from './components/MainFooter'

export default function Footer() {
  return (
    <>
    <SubFooter/>
    <MainFooter/>
    </>
  )
}
